import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { QUERY_STALE_TIME, isSupabaseConfigured } from '@/config';
import { useAuth } from '@/lib/auth/AuthProvider';
import {
  getSurvivorLeaderboard,
  getSurvivorState,
  recordMissionEvent,
  submitSurvivorPick,
} from '@/lib/data/provider';

/** The caller's Survivor status + the active round's options + history. */
export function useSurvivorState() {
  const { userId } = useAuth();
  return useQuery({
    queryKey: ['survivor', 'state', userId ?? 'anon'],
    queryFn: getSurvivorState,
    staleTime: QUERY_STALE_TIME.live,
    enabled: isSupabaseConfigured,
  });
}

export function useSubmitSurvivorPick() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (teamId: string) => submitSurvivorPick(teamId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['survivor'] });
      void recordMissionEvent('survivor')
        .then(() => queryClient.invalidateQueries({ queryKey: ['rewards'] }))
        .catch(() => {});
    },
  });
}

export function useSurvivorLeaderboard(enabled = true) {
  return useQuery({
    queryKey: ['survivor', 'leaderboard'],
    queryFn: () => getSurvivorLeaderboard(),
    staleTime: QUERY_STALE_TIME.user,
    enabled: isSupabaseConfigured && enabled,
  });
}
